import styled from "styled-components"

const Title = styled.h2`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`
const ZoneLibre = styled.div`
  background-color: ${(props) => props.bgColor};
  @media (max-width: 600px) {
    background-color: ${(props) =>
      props.bgColorMobile !== "white" ? props.bgColorMobile : "white"};
  }
`

const SeeNextLink = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  font-weight: bold;
  display: inline-block;
`

export { Title, ZoneLibre, SeeNextLink }
